module.exports = __webpack_public_path__ + "images/emoji/trello.3ac0d202d311a21c54d1.png";